import devtools from '@vue/devtools';

if (process.env.VUE_APP_QBIC === 'enabled') {
  // this defaults to localhost:8098
  // if remote debugging add a port forwarding rule
  //
  // run ./node_modules/.bin/vue-devtools to launch the tool
  devtools.connect();
}
